import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Button } from '../components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { toast } from 'sonner';
import { Building2, Loader2 } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const CSRLogin = ({ setCSRPartner }) => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await axios.post(`${API}/csr/login`, { email, password });
      localStorage.setItem('csr_token', response.data.token);
      localStorage.setItem('csr_partner', JSON.stringify({
        name: response.data.name,
        organization: response.data.organization,
        assigned_schools: response.data.assigned_schools,
        assigned_coupons: response.data.assigned_coupons
      }));
      setCSRPartner(response.data);
      toast.success(`Welcome, ${response.data.name}!`);
      navigate('/csr/dashboard');
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-teal-50 via-white to-emerald-50 flex items-center justify-center p-4">
      <Card className="w-full max-w-md bg-white/90 backdrop-blur-md rounded-2xl border border-teal-200 shadow-xl">
        <CardHeader className="text-center pb-2">
          <div className="flex justify-center mb-4">
            <div className="w-16 h-16 bg-gradient-to-br from-teal-500 to-emerald-500 rounded-2xl flex items-center justify-center">
              <Building2 className="w-8 h-8 text-white" />
            </div>
          </div>
          <CardTitle className="font-heading text-2xl text-slate-900">CSR Partner Portal</CardTitle>
          <p className="text-slate-600 text-sm mt-2">Access your student enrollment dashboard</p>
        </CardHeader>
        <CardContent>
          <form onSubmit={handleLogin} className="space-y-4">
            <div className="space-y-2">
              <Label htmlFor="email">Email</Label>
              <Input
                id="email"
                type="email"
                data-testid="csr-email-input"
                placeholder="partner@organization.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="rounded-lg border-slate-200"
              />
            </div>
            <div className="space-y-2">
              <Label htmlFor="password">Password</Label>
              <Input
                id="password"
                type="password"
                data-testid="csr-password-input"
                placeholder="Enter your password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                className="rounded-lg border-slate-200"
              />
            </div>
            <Button
              type="submit"
              data-testid="csr-login-btn"
              disabled={loading}
              className="w-full bg-gradient-to-r from-teal-500 to-emerald-500 hover:from-teal-600 hover:to-emerald-600 text-white rounded-full py-3 font-semibold"
            >
              {loading ? (
                <>
                  <Loader2 className="w-4 h-4 mr-2 animate-spin" />
                  Logging in...
                </>
              ) : (
                'Login to Dashboard'
              )}
            </Button>
          </form>
          
          <div className="mt-6 pt-4 border-t border-slate-200 text-center">
            <p className="text-sm text-slate-500">
              Not a CSR partner?{' '}
              <a href="/" className="text-teal-600 hover:text-teal-700 font-medium">
                Go to main site
              </a>
            </p>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default CSRLogin;
